import styled, { css, keyframes } from 'styled-components';
import { select } from '@panel/commons/core/themev2';

const filled = keyframes`
    0% { width: 0%; }
    100% { width: ${({ fill }) => fill}%;}
  `;

const ContainerProgressBar = styled.div`
  height: 10px;
  width: 100%;
  background-color: ${({ emptyColor }) => select(emptyColor || 'lightGray')};
  border-radius: 8px;
  overflow: hidden;
  background-color: ${({ active, hoverColor }) => (active && hoverColor ? select('midLightGray') : 'none')};
`;

const BarFilled = styled.div`
  height: 10px;
  width: ${({ fill }) => `${fill}%` || '0%'};
  background-color: ${({ filledColor }) => select(filledColor || 'yellow')};
  border-radius: 8px;
  animation: ${filled} 1s ease-out;
  ${({ active }) =>
    active &&
    css`
      background-color: ${({ hoverColor }) => select(hoverColor || 'none')};
    `}
`;

export { ContainerProgressBar, BarFilled };
